function NotFound() {
  return (
    <div>
      <h1 className="not-found-title">Page Not Found!</h1>
    </div>
  );
}

export default NotFound;
